import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'
import MediaWithShimmer from '../components/MediaWithShimmer'
import celestImage from '../imgs/celest.png'

const AliensFromMars = () => {
  const { language } = useLanguage()

  return (
    <div className="min-h-screen bg-white">
      {/* Spacer for header - same as home page */}
      <div id="aliens-spacer" style={{ height: '10rem', display: 'block' }}>&nbsp;</div>
      
      {/* Hero Section with Image */}
      <section className="relative w-full">
        <div className="relative w-full aspect-[0.8/1] md:aspect-[1.773399/1]">
          <MediaWithShimmer
            src={celestImage}
            alt="Aliens From Mars Collection 2026"
            className="w-full h-full object-cover"
          />
          
          {/* Overlay Content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center md:justify-end -mb-20 md:mb-0 md:pb-16 lg:pb-20">
            {/* Collection Logo */}
            <div className="mb-0 md:mb-8 w-48 md:w-64 lg:w-80">
              <div className="p-6 md:p-8">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white text-center tracking-[0.1em] uppercase playfair">
                  <span className="block">ALIENS</span>
                  <span className="block mt-1">FROM</span>
                  <span className="block mt-1 text-[#CEA15F]">MARS</span>
                </h1>
              </div>
            </div>

            {/* CTA Button */}
            <a
              href="#collection"
              className="inline-flex items-center gap-3 px-8 md:px-10 py-3 md:py-4 bg-white text-black text-xs md:text-sm tracking-[0.2em] uppercase font-semibold hover:bg-[#CEA15F] hover:text-white transition-all duration-300 montserrat"
            >
              <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-2 h-3">
                <path d="M0 14V0L10 7L0 14Z" fill="currentColor" />
              </svg>
              <span>{language === 'ru' ? 'Смотреть коллекцию' : 'See the Collection'}</span>
            </a>
          </div>
        </div>
      </section>

      {/* Collection Grid */}
      <section id="collection" className="bg-white px-4 md:px-8 lg:px-16 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
              <div key={item} className="group cursor-pointer">
                <div className="relative aspect-[3/4] bg-gray-200 overflow-hidden">
                  <img
                    src={`https://via.placeholder.com/400x533/E5E5E5/999999?text=Look+${item}`}
                    alt={`Aliens From Mars Look ${item}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="mt-3 text-center">
                  <p className="text-xs md:text-sm tracking-[0.15em] uppercase montserrat">
                    Look {item}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Spacer */}
      <div className="h-16 md:h-20 lg:h-24"></div>

      {/* About Collection Section - Mobile */}
      <section className="block md:hidden bg-white px-4 py-8">
        <div className="max-w-xl mx-auto space-y-6">
          <div className="w-full">
            <MediaWithShimmer
              src="https://via.placeholder.com/400x450/F5F5F5/000000?text=Collection+Image"
              alt="Aliens From Mars"
              className="w-full h-auto object-cover"
            />
          </div>

          <div className="space-y-4">
            <h2 className="text-2xl md:text-3xl font-light text-center tracking-[0.15em] uppercase playfair">
              {language === 'ru' 
                ? 'Откройте для себя мир ALRICHE Haute Couture'
                : 'Discover the world of ALRICHE Haute Couture'}
            </h2>

            <Link
              to="/shop"
              className="block w-full text-center px-8 py-3 bg-black text-white text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#CEA15F] transition-all duration-300 montserrat"
            >
              {language === 'ru' ? 'Узнать больше' : 'Discover more'}
            </Link>
          </div>
        </div>
      </section>

      {/* About Collection Section - Desktop */}
      <section className="hidden md:grid grid-cols-2 gap-0 bg-white px-8 lg:px-16 py-12">
        <div className="flex items-center justify-center">
          <div className="w-full max-w-md">
            <MediaWithShimmer
              src="https://via.placeholder.com/400x450/F5F5F5/000000?text=Collection+Image"
              alt="Aliens From Mars"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>

        <div className="flex flex-col items-center justify-center space-y-6 px-8">
          <div className="w-full max-w-lg">
            <div className="relative" style={{ aspectRatio: '1.239535' }}>
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#F5F5F5] p-8">
                <h2 className="text-2xl lg:text-3xl font-light text-center tracking-[0.15em] uppercase playfair mb-6">
                  {language === 'ru' 
                    ? 'МИР HAUTE COUTURE'
                    : 'THE WORLD OF HAUTE COUTURE'}
                </h2>

                <Link
                  to="/shop"
                  className="inline-block px-10 py-3 bg-black text-white text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#CEA15F] transition-all duration-300 montserrat"
                >
                  {language === 'ru' ? 'Узнать больше' : 'Discover more'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Spacer */}
      <div className="h-16 md:h-20 lg:h-24"></div>

      {/* Collection Description */}
      <section className="bg-white px-4 py-12">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-light tracking-[0.15em] uppercase playfair">
            {language === 'ru' ? 'О коллекции' : 'About the Collection'}
          </h3>
          
          <div className="space-y-4 text-sm md:text-base lg:text-lg text-gray-700 montserrat leading-relaxed">
            <p>
              {language === 'ru'
                ? 'Коллекция "ALIENS FROM MARS" 2026 года от кутюрье ANGELINA ALRICHE — это смелое путешествие в будущее моды. Вдохновленная космосом и инопланетными мирами, коллекция представляет собой уникальное сочетание футуристических форм и традиций haute couture.'
                : 'The "ALIENS FROM MARS" 2026 collection by couturier ANGELINA ALRICHE is a bold journey into the future of fashion. Inspired by space and alien worlds, the collection represents a unique combination of futuristic forms and haute couture traditions.'}
            </p>
            <p>
              {language === 'ru'
                ? 'Необычные текстуры, инновационные материалы и авангардные силуэты создают образы, которые переносят нас за пределы земной реальности. Каждое изделие — это произведение искусства, созданное вручную с безупречным вниманием к деталям.'
                : 'Unusual textures, innovative materials, and avant-garde silhouettes create images that transport us beyond earthly reality. Each piece is a work of art, handcrafted with impeccable attention to detail.'}
            </p>
          </div>
        </div>
      </section>

      {/* Spacer */}
      <div className="h-16 md:h-20 lg:h-24"></div>
    </div>
  )
}

export default AliensFromMars
